import { Injectable } from '@angular/core';
import { IM365AppDefinition } from '@office-start/app-host-types';

import { BehaviorSubject, Observable } from 'rxjs';

import { LocalStorageService } from '../shared/services/local-storage.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';

@Injectable({
    providedIn: 'root'
})
export class M356AppsSideLoadingService {
    private readonly sideLoadingEnabled: boolean;
    private readonly sideloadedAppsKey: string = 'sideloadedApps';

    private readonly _sideloadedAppsSubject : BehaviorSubject<ReadonlyArray<IM365AppDefinition>> = new BehaviorSubject([]);
    private readonly _sideloadedAppsSubjectObservable : Observable<ReadonlyArray<IM365AppDefinition>>  = this._sideloadedAppsSubject.asObservable();

    constructor(
        private readonly localStorageService: LocalStorageService,
        capabilitiesService: CapabilitiesService
        ) {

        this.sideLoadingEnabled = capabilitiesService.capabilities.m365AppsEnabled;
        this.loadAppDefinitions();
    }

    public saveAppsForSideloading(appEntries: ReadonlyArray<string>)  {
        if (!this.sideLoadingEnabled) {
            return;
        }

        try {
            this.localStorageService.set(this.sideloadedAppsKey, appEntries);
        } catch (exception) {
            console.log(`Failed to add apps for sideLoading ${exception}`);
        }

        this.loadAppDefinitions();
    }

    private loadAppDefinitions(): void {
        const appDefinitions = this.fetchAppDefinitions();
        this._sideloadedAppsSubject.next(appDefinitions);
    }

    public get m365SideLoadedAppsSource(): Observable<ReadonlyArray<IM365AppDefinition>> {
        return this._sideloadedAppsSubjectObservable;
    }

    public get m365SideLoadedApps(): ReadonlyArray<IM365AppDefinition> {
        return this._sideloadedAppsSubject.value;
    }

    private fetchAppDefinitions(): ReadonlyArray<IM365AppDefinition> {
        if (!this.sideLoadingEnabled) {
            return [];
        }

        try {
            // read App Definitions from LocalStorage for sideloading
            const sideloadedAppsData: ReadonlyArray<string> = this.localStorageService.get(this.sideloadedAppsKey) || [];
            return sideloadedAppsData.map(definition => JSON.parse(definition));
        } catch {
            console.log('Failed to sideload M365Apps - remove sideLoadedApps key from localstorage');
        }

        return [];
    }
}
